import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, catchError } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ScheduledActivity {
  id: number;
  title: string;
  status: string;
  scheduled_date: string;
  start_time: string;
  duration_minutes?: number;
  notes?: string;
  activity_type?: {
    id: number;
    name: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class ActivityScheduleSimpleService {
  private readonly baseUrl = `${environment.interop.basePath}api/activity-schedule`;

  constructor(private http: HttpClient) { }

  getStatusOptions(): Array<{ key: string; label: string; color: string }> {
    return [
      { key: 'scheduled', label: 'Programată', color: '#2196F3' },
      { key: 'completed', label: 'Finalizată', color: '#4CAF50' },
      { key: 'cancelled', label: 'Anulată', color: '#F44336' },
      { key: 'rescheduled', label: 'Reprogramată', color: '#FF9800' },
      { key: 'no_show', label: 'Absent', color: '#9E9E9E' }
    ];
  }

  getCerereActivities(cerereId: number): Observable<ScheduledActivity[]> {
    // Return empty array for now - will be implemented when backend is ready
    return of([]);
  }

  getCalendarActivities(userId: number, startDate: string, endDate: string): Observable<ScheduledActivity[]> {
    // Return empty array for now - will be implemented when backend is ready
    return of([]);
  }

  deleteActivity(activityId: number): Observable<boolean> {
    return this.http.delete<{ success: boolean; message: string }>(`${this.baseUrl}/activity/${activityId}`)
      .pipe(
        map(response => response.success),
        catchError(error => {
          console.error('Error deleting activity:', error);
          throw error;
        })
      );
  }

  // User Availability Methods (Backend Integration)
  getUserAvailability(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/availability/user`, {
      params: { user_id: userId.toString() }
    }).pipe(
      catchError(error => {
        console.error('Error loading user availability:', error);
        return of([]);
      })
    );
  }

  setUserAvailability(userId: number, availabilitySlots: any[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/availability/user`, {
      user_id: userId,
      availability: availabilitySlots
    }).pipe(
      catchError(error => {
        console.error('Error saving user availability:', error);
        throw error;
      })
    );
  }

  saveUserAvailability(userId: number, availabilityData: any[]): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/availability/user`, {
      user_id: userId,
      availability_data: availabilityData
    }).pipe(
      catchError(error => {
        console.error('Error saving user availability:', error);
        throw error;
      })
    );
  }
}

export interface UserAvailability {
  id: number;
  user_id: number;
  day_of_week: number;
  start_time: string;
  end_time: string;
  active: boolean;
  notes?: string;
  created_at: string;
  updated_at: string;
}